module.exports = __webpack_public_path__ + "8db1ed19f334e7b5ad26ae407f199798.svg";